import React, { useState, useEffect, useMemo } from 'react';
import { Col, Row, Select } from 'antd';
import moment from 'moment';
import EdenredButton from '@sharedComponent/button';
import EdenredTypo from '@sharedComponent/typography';
import ImageComponent from '@sharedComponent/image-component';
import { icons } from 'src/assets/icons';
import { Link, useHistory, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import { getYears } from '@helpers';
import EdenredHeader from '@pages/main-layout/components/main-header';
import PayrollService from 'src/services/payroll-service';
import ClevertapReact from 'src/utils/clever-tap';
import UploadPayrollPopup from 'src/utils/uploadPayrollPopup';

const { Option } = Select;

const WpsPayroll = ({ history }) => {
	const customStyles = {
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: 'rgba(255, 255, 255, 0.75)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		content: {
			position: 'absolute',
			top: '16rem',
			left: '1rem',
			right: '0',
			bottom: 'auto',
			border: 'none',
			background: 'white',
			overflow: 'auto',
			borderRadius: '16px',
			outline: 'none',
			padding: '15px',
			width: '90%',
			boxShadow: '0px 10px 20px rgba(174, 182, 183, 0.5)',
		},
	};

	const yearLength = 6;
	const [years, setyears] = useState(
		getYears(1, 1).map((year) => {
			return {
				value: year,
			};
		})
	);
	const [currentIndex, setcurrentIndex] = useState(0);
	const [indexObject, setindex] = useState({
		start: currentIndex,
		end: currentIndex + yearLength,
	});
	const { start, end } = indexObject;
	const hasPreviousData = start >= yearLength;
	const hasNextData = years.slice(end, end + yearLength).length !== 0;
	const yearData = years.slice(indexObject.start, indexObject.end);
	// const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
	const [selectedYear, setSelectedYear] = useState(null);
	/*
	 * Added a state for enabling or diabling button based on popup
	 * Added a state for showing and closing popup
	 * Added a memo value to store selected date to show inside popup
	 */
	const [buttonState, setButtonState] = useState(true);
	const [showDateConfirmPopup, setShowDateConfirmPopup] = useState(false);
	const [savedSelectedDate, setSavedSelectedDate] = useState(null);

	/*
	 * Selected Dates
	 */
	const [thisMonth, setThisMonth] = useState(null);
	const [thisYear, setThisYear] = useState(null);
	const [year, setYear] = useState();
	const [month, setMonth] = useState();

	const monthListDD = [
		{ month: '01', index: 0, label: 'January', isSelected: false },
		{ month: '02', index: 1, label: 'February', isSelected: false },
		{ month: '03', index: 2, label: 'March', isSelected: false },
		{ month: '04', index: 3, label: 'April', isSelected: false },
		{ month: '05', index: 4, label: 'May', isSelected: false },
		{ month: '06', index: 5, label: 'June', isSelected: false },
		{ month: '07', index: 6, label: 'July', isSelected: false },
		{ month: '08', index: 7, label: 'August', isSelected: false },
		{ month: '09', index: 8, label: 'September', isSelected: false },
		{ month: '10', index: 9, label: 'October', isSelected: false },
		{ month: '11', index: 10, label: 'November', isSelected: false },
		{ month: '12', index: 11, label: 'December', isSelected: false },
	];
	const [Months, setMonths] = useState([]);
	const dateMonth = new Date();
	const mDateMonth = moment(dateMonth).format('MM');
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [viewMonthModal, setViewMonthModal] = useState(false);
	const [viewYearModal, setViewYearModal] = useState(false);

	const handleYears = (type) => {
		switch (type) {
			case 'PRE':
				if (hasPreviousData) {
					setindex({
						...indexObject,
						start: start - yearLength,
						end: end - yearLength,
					});
				}
				break;
			case 'AFT':
				if (hasNextData) {
					setindex({
						...indexObject,
						start: start + yearLength,
						end: end + yearLength,
					});
				}
				break;

			default:
				break;
		}
	};

	const openMonthModal = () => {
		setViewMonthModal(true);
	};

	const closeMonthModal = () => {
		setViewMonthModal(false);
	};

	const openYearModal = () => {
		setViewYearModal(true);
	};

	const closeYearModal = () => {
		setViewYearModal(false);
	};

	const isMonthSelected = (month) => {
		initializeMonth(month && month.index);
	};

	const payrollService = new PayrollService();

	const getLastProccedMonth = () => {
		payrollService.getLastProccedMonth().then((res) => {
			if (res && res.data) {
				setSelectedYear(
					`${res.data.toString().charAt(0)}${res.data.toString().charAt(1)}${res.data.toString().charAt(2)}${res.data.toString().charAt(3)}`
				);
				// initializeMonth1(new Date().getMonth(`${res.data.toString().charAt(4)}${res.data.toString().charAt(5)}`));
				initializeMonth1(`${res.data.toString().charAt(4)}${res.data.toString().charAt(5)}`);
			} else {
				setSelectedYear(new Date().getFullYear());
				initializeMonth(new Date().getMonth());
			}
		});
	};

	const initializeMonth1 = (data) => {
		let months = monthListDD;
		months.map((month, i) => {
			if (month.month == data) {
				month.isSelected = true;
				// setSelectedMonth(month.label); // TODO: FOR MONTH STRING
				setSelectedMonth(moment().month(month.label).format('MM')); // TODO: FOR MONTH NUMBER
			} else {
				month.isSelected = false;
			}
		});
		setMonths([...months]);
		closeMonthModal();
	};

	useEffect(() => {
		setMonths(monthListDD);
		// setSelectedMonth(moment().month(monthListDD[new Date().getMonth()].label).format('MM'));
		setSelectedMonth(null);
		// getLastProccedMonth();
	}, []);

	useEffect(() => {
		Modal.setAppElement('body');
	}, [Modal]);

	const initializeMonth = (data) => {
		let months = monthListDD;
		months.map((month, i) => {
			if (month.index === data) {
				setSelectedMonth(moment().month(month.label).format('MM'));
				setMonth(moment().month(month.label).format('MM'))
				month.isSelected = true;
			} else {
				month.isSelected = false;
			}
		});
		setMonths([...months]);
		closeMonthModal();
	};

	const handleChangeMonth = (monthItem, mont) => {
		setMonth(parseInt(monthItem));
		if (mont.children) {
			setSelectedMonth(moment().month(mont.children).format('MM'));
		} else {
			setSelectedMonth(moment().month(monthItem).format('MM'));
		}
		/*
		 * Requirement: Need to display popup when, selected month is 3 months fwd or bwd.
		 * Extracting selected month and date as int and passing it to popup handler function
		 * So that we can build the date inside popup handler.
		 */
		let clickedMonth = parseInt(mont.key) + 1;
		let clickedYear = selectedYear;

		setThisMonth(clickedMonth);
		//setThisYear(clickedYear);

		//popuphandler(clickedMonth, clickedYear);
	};

	const handleChangeYear = async (year) => {
		setYear(year);
		let selectedYear = (await year) || null;
		let currentMonth = await new Date().getMonth();
		let currentYear = await new Date().getFullYear();

		if (currentYear > selectedYear) {
			await setSelectedMonth(null);
			let month = await monthListDD.filter((val) => val.index >= currentMonth);
			await setMonths([...month]);
		} else if (currentYear < selectedYear) {
			await setSelectedMonth(null);
			let month = await monthListDD.filter((val) => val.index <= currentMonth);
			await setMonths([...month]);
		} else {
			await setMonths([...monthListDD]);
		}
		await setSelectedYear(year);
	};

	const { state } = useLocation();

	const handlenect = () => {
		ClevertapReact.event('Next_MthYear', { Type: 'Wps' });
		history.push({
			pathname: '/payroll/run/channel/now_or_later',
			state: { ...state, payrollForMonth: selectedMonth, payrollForYear: selectedYear },
		});
	};

	/*
	 * Popup handler to handle popups.
	 * Building date using passed params as dateSelected
	 */
	const popuphandler = (month, year) => {
		let dateSelected;
		let currentYear = moment().format('YYYY');
		if (year > currentYear || year === currentYear) {
			dateSelected = moment(`${year}-${month}-01`);
		} else {
			dateSelected = moment(`${year}-${month}-01`);
		}
		let stringDate = moment(dateSelected).format('MMMM YYYY');
		setSavedSelectedDate(stringDate);

		//creating match month to check month difference
		let matchMonth = moment().diff(dateSelected, 'months');

		if (matchMonth > 2) {
			setShowDateConfirmPopup(true);
		} else if (matchMonth < -1) {
			setShowDateConfirmPopup(true);
		} else {
			handlenect();
		}
	};

	/*
	 * handling popup state when no is pressed, setting button as disables also
	 */
	const popupClosehandler = () => {
		setShowDateConfirmPopup(false);
		setButtonState(true);
	};

	useEffect(() => {
		disableButtonHandler();
	}, [selectedMonth, selectedYear]);
	const disableButtonHandler = () => {
		if (selectedMonth && selectedYear) {
			setButtonState(false);
		} else {
			setButtonState(true);
		}
	};
		
	return (
		<>
			<EdenredHeader />
			<Row className="wps_payroll_container">
				<Col xl={18} lg={18} md={23} sm={24} xs={24} className="wps_payroll_header">
					<EdenredTypo>What Month And Year Is This WPS Payroll For?</EdenredTypo>
				</Col>
				<Col xl={22} lg={16} md={23} sm={24} xs={24} className="wps_payroll_description">
					<EdenredTypo>
						Select the month and date of the employees' salary records with the Ministry of Labour under the WPS system.
					</EdenredTypo>
				</Col>
				<Row className="wps_payroll_select_desktop_section">
					<Col xl={5} lg={5} md={10} className="wps_payroll_month">
						<Select
							value={selectedMonth}
							placeholder="Select Month"
							onChange={handleChangeMonth}
							dropdownClassName="select_month_dropdown">
							{Months &&
								Months.map((monthItem, index) => {
									return (
										<Option key={index} value={monthItem.month}>
											{monthItem.label}
										</Option>
									);
								})}
						</Select>
					</Col>
					<Col xl={5} lg={5} md={10} className="wps_payroll_month">
						<Select value={selectedYear} placeholder="Select Year" onChange={handleChangeYear}>
							{years.map((year, index) => (
								<Option key={index} value={year.value}>
									{year.value}
								</Option>
							))}
						</Select>
					</Col>
				</Row>
				<Row className="wps_payroll_select_mobile_section">
					<Col sm={11} xs={11} className="wps_payroll_select_month" onClick={openMonthModal}>
						<EdenredTypo medium>
							{Months &&
								Months.filter((month) => month.isSelected === true)[0] &&
								Months.filter((month) => month.isSelected === true)[0].label}
						</EdenredTypo>
						<ImageComponent src={icons.not_focus.Down} />
					</Col>
					<Modal isOpen={viewMonthModal} onRequestClose={closeMonthModal} style={customStyles}>
						<Row>
							{Months &&
								Months.map((monthItem, index) => {
									return (
										<Col sm={3} style={{ padding: '1% 1% 1% 1%' }}>
											<EdenredButton
												onClick={() => isMonthSelected(monthItem)}
												className={monthItem.isSelected === true ? 'isSelected month_modal_button' : 'month_modal_button'}>
												{monthItem.label}
											</EdenredButton>
										</Col>
									);
								})}
						</Row>
					</Modal>
					<Col sm={11} xs={11} className="wps_payroll_select_year" onClick={openYearModal}>
						<EdenredTypo medium>{selectedYear || new Date().getFullYear()}</EdenredTypo>
						<ImageComponent src={icons.not_focus.Down} />
					</Col>
					<Modal isOpen={viewYearModal} onRequestClose={closeYearModal} style={customStyles}>
						<Row className="date_modal">
							<Col sm={2} xs={2} className="icon_area" onClick={() => hasPreviousData && handleYears('PRE')}>
								{hasPreviousData ? <ImageComponent src={icons.not_focus.Down} className="left_arrow" /> : ''}
							</Col>
							<Col sm={20} xs={20}>
								<Row>
									{yearData.map((year, i) => (
										<Col key={i} sm={8} xs={8} style={{ padding: '1% 1% 1% 1%' }}>
											<EdenredButton
												onClick={() => {
													setSelectedYear(year.value);
													setYear(year.value)
													setThisYear(year.value);
													closeYearModal();
												}}
												className={`${selectedYear === year.value ? 'isSelected' : ''} month_modal_button`}>
												{year.value}
											</EdenredButton>
										</Col>
									))}
								</Row>
							</Col>
							<Col sm={2} xs={2} className="icon_area" onClick={() => hasNextData && handleYears('AFT')}>
								{hasNextData ? <ImageComponent src={icons.not_focus.Down} className="right_arrow" /> : ''}
							</Col>
						</Row>
					</Modal>
					<UploadPayrollPopup
						visible={showDateConfirmPopup}
						message={`You have selected ${savedSelectedDate}, are you sure?`}
						closePopup={() => popupClosehandler()}
						autoFixEmployeeFileError={() => handlenect()}
						okText="Yes"
						cancelText="No"
					/>
				</Row>
				<Col xl={8} lg={8} md={8} sm={24} xs={24} className="wps_payroll_button">
					<EdenredButton disabled={buttonState} onClick={() => popuphandler(month, year)}>
						Next
					</EdenredButton>
					{/* </Link> */}
				</Col>
			</Row>
		</>
	);
};

export default WpsPayroll;
